import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { HAS_DETAIL_VIEW_ONE_PERMISSION_OF, PERMISSIONS } from '@/constants/permissions.ts'

const routePrintDesignerHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/settings/printFormats/ViewPrintFormat.vue')
  },
  meta: {
    detail: { doctype: DOCTYPES.PRINT_FORMAT, perm_type: PERMISSIONS.READ },
    doctypes: { [DOCTYPES.PRINT_FORMAT]: HAS_DETAIL_VIEW_ONE_PERMISSION_OF },
  },
  name: 'print-designer-home',
  path: ':id',
}

const routePrintDesignerRoot: RouteRecordRaw = {
  children: [routePrintDesignerHome],
  path: 'print-designer',
}

export { routePrintDesignerHome, routePrintDesignerRoot }
